<template>
  <div>
  <ul class="sidebar-menu" v-if="proyectos.length > 0">
    <li class="header"></li>

    <li class="treeview">
      <a href="#">
      <i class="fa fa-archive"></i>
       <span>Proyectos</span>
        <span class="pull-right-container">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu">  
        <li class="treeview" v-for="item in proyectos">
          <a href="#">
            <i class="fa fa-folder"></i>
            <span class="menu-cod-proy">{{ item.codigo_proyecto }}</span>
            <!--span class="pull-right-container">
              <i class="fa fa-angle-left fa-fw pull-right"></i>
            </span-->
          </a> 
          <ul class="treeview-menu subitems">   
            <router-link tag="li" class="pageLink" :to="'/proyecto/' + item.codigo_proyecto + '/info'">
              <a>
                <i class="far fa-info-circle"></i>
                <span class="page">Informacion</span>
              </a>
            </router-link>  
            <template v-for="(link, index) in item.simaapplink">
              <router-link v-if="link.tipo === 'iframe'" tag="li" class="pageLink" :to="'/proyecto/' + item.codigo_proyecto + '/iframe/' + index">
                <a>
                  <i class="far fa-code"></i>
                  <span class="page">{{ link.cta_text ? link.cta_text : '-Sin nombre-' }}</span>
                </a>
              </router-link>
              <li class="pageLink" v-else>
                <a :href="link.cta_link_or_iframe_src" target="_blank">
                  <i class="fa fa-external-link-alt"></i>
                  <span class="page">{{ link.cta_text }}</span>
                </a>                
              </li>
            </template>
            <router-link tag="li" class="pageLink" :to="'/proyecto/' + item.codigo_proyecto + '/reportes-media'">
              <a>
                <i class="far fa-chart-pie"></i>
                <span class="page">Reportes & Media</span>
              </a>
            </router-link>
            <router-link tag="li" class="pageLink" :to="'/proyecto/' + item.codigo_proyecto + '/compras'">
              <a>
                <i class="fa fa-shopping-basket"></i>
                <span class="page">Compras</span>
              </a>
            </router-link>         
            <!--router-link tag="li" class="pageLink" :to="'/proyecto/' + item.codigo_proyecto + '/parte-diario'">
              <a>
                <i class="fa fa-file"></i>
                <span class="page">Parte Diario</span>
              </a>
            </router-link-->                 
          </ul>         
        </li>
      </ul>
    </li>

    <!--li class="treeview">
      <a href="#">
        <i class="fa fa-clipboard-list"></i>
        <span>Formularios</span>
        <span class="pull-right-container">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu subitems">   
        <router-link tag="li" class="pageLink" :to="'/formularios/parte-diario'">
          <a>
            <i class="fa fa-plus-square"></i>
            <span class="page">Parte Diario</span>
          </a>
        </router-link>  
      </ul>
    </li-->

    <li class="treeview">
      <a href="#">
        <i class="fa fa-shopping-basket"></i>
        <span>Mis Compras</span>
        <span class="pull-right-container">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu subitems"> 
        <li class="treeview">
          <router-link tag="a" class="" :to="'/mis-compras/enprogreso'">
            <i class="far fa-sync"></i>
            <span>En Progreso</span>
          </router-link>
          <ul class="treeview-menu subitems">   
            <router-link tag="li" class="pageLink" :to="'/mis-compras/solicitados'">
              <a>
                <i class="fa fa-minus"></i>
                <span class="page">Solicitados</span>
              </a>
            </router-link>  
            <router-link tag="li" class="pageLink" :to="'/mis-compras/aprobados'">
              <a>
                <i class="fa fa-minus"></i>
                <span class="page">Aprobados</span>
              </a>
            </router-link>        
            <router-link tag="li" class="pageLink" :to="'/mis-compras/comprados'">
              <a>
                <i class="fa fa-minus"></i>
                <span class="page">Comprados</span>
              </a>
            </router-link>
          </ul>          
        </li>
        <router-link tag="li" class="pageLink" :to="'/mis-compras/completado'">
          <a>
            <i class="far fa-check-circle"></i>
            <span class="page">Completados</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" :to="'/mis-compras/archivo'">
          <a>
            <i class="far fa-archive"></i>
            <span class="page">Archivados</span>
          </a>
        </router-link>
      </ul>
    </li>
  </ul>
  <ul class="sidebar-menu" v-if="proyectos.length == 0">
    <li class="header" style="color:#fff;">Sin proyectos asignados</li>
  </ul>
  </div>
</template>
<script>
export default {
  name: 'SidebarMenu',
  computed: {
    proyectos () {
      return this.$store.state.apiData.proyectos
    }
  },
  data () {
    return {
    }
  }
}
</script>
<style>
/* override default */
.sidebar-menu > li > a {
  padding: 12px 15px 12px 15px;
}
.menu-cod-proy {
  font-weight: bold;
}

.treeview-menu.subitems li>a{
    padding: 8px 5px 8px 5px;
    font-size: 15px;
}
.sidebar-menu li.active > a > .fa-angle-left,
.sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
  animation-name: rotate;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
}

.treeview-title {
  z-index: 1;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarMenu.vue